import { useEffect, useState } from "react";

import { cn } from "../../lib/utils";
import { Input } from "./input";

const HEX = /^#?([0-9a-f]{6})$/i;

/**
 * A color as a 6-digit hex code, with a swatch of the current value. The value changes once the
 * text is a valid color; leaving the field with anything else restores it.
 */
function ColorField({
	value,
	onValueChange,
	className,
	"aria-label": ariaLabel,
}: {
	value: string;
	onValueChange: (value: string) => void;
	className?: string;
	"aria-label": string;
}) {
	const [draft, setDraft] = useState(value);
	useEffect(() => setDraft(value), [value]);
	return (
		<div
			data-slot="color-field"
			className={cn("relative flex w-full items-center sm:w-40", className)}
		>
			<span
				aria-hidden
				className="pointer-events-none absolute left-2 size-4 rounded-sm border border-hairline-strong"
				style={{ backgroundColor: value }}
			/>
			<Input
				aria-label={ariaLabel}
				autoComplete="off"
				className="pl-8 font-mono uppercase"
				maxLength={7}
				onBlur={() => setDraft(value)}
				onChange={(event) => {
					const text = event.target.value;
					setDraft(text);
					const match = HEX.exec(text.trim());
					if (match?.[1]) onValueChange(`#${match[1].toLowerCase()}`);
				}}
				spellCheck={false}
				value={draft}
			/>
		</div>
	);
}

export { ColorField };
